// Use this file so we can require the right path and still mock the library easily
import NoSleep from 'nosleep.js/dist/NoSleep';
export default NoSleep;



// WEBPACK FOOTER //
// ./src/no-sleep.js